export const groupBy = <K, V>(array: V[], grouper: (item: V) => K) =>
  array.reduce((acc, item) => {
    const key = grouper(item);
    if (!acc.has(key)) {
      acc.set(key, [item]);
    } else {
      acc.get(key)!.push(item);
    }
    return acc;
  }, new Map<K, V[]>());

export const uniqueBy = <K, V>(array: V[], grouper: (item: V) => K) => {
  const map = array.reduce((acc, item) => {
    const key = grouper(item);
    if (!acc.has(key)) {
      acc.set(key, item);
    }
    return acc;
  }, new Map<K, V>());
  return Array.from(map.values());
};

export const shuffle = <T>(array: T[]): T[] => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};
